import {checkPassport} from '@router/guards/roleGuard'
export default {
  path: '/justification',
  component: () => import('@views/Justification/Index'),
  beforeEnter: checkPassport,
  children: [
    {
      path: 'index',
      name: 'justification.index',
      component: () => import('@/components/Justification/Justification')
    },
  ]
}
